import React from "react";
import { Chart } from "react-google-charts";


export const AssigneeChart = ({ userRoleWiseGraphData }) => {
    let userRoleWiseGraphDataArray = [["Year", "Student", "Teaching", "Non Teaching"]];
    userRoleWiseGraphData && Object.keys(userRoleWiseGraphData).map(key => {
        userRoleWiseGraphDataArray.push([key, userRoleWiseGraphData[key].student, userRoleWiseGraphData[key].teaching, userRoleWiseGraphData[key].nonteaching])
    });

    const options = {
        curveType: "function",
        colors: ['#2F80ED', '#219653'],
        legend: { position: "none" },
    };
    return (
        <div className="p-0 m-0">
            { 
                userRoleWiseGraphDataArray.length > 1 ?
                    <Chart
                        chartType="LineChart"
                        width="full"
                        height="100%"
                        data={ userRoleWiseGraphDataArray }
                        options={ options }
                    />
                :
                    <p style={{ margin: 20, color: '#818181', fontSize: 14 }}>No details found for assignees.</p>
            }
        </div>
    );
}
